module.exports = __webpack_public_path__ + "img/txt.06646fc3.png";